import Immutable from 'immutable'

export const SharedHostingRecord = Immutable.Record({
  domain: null,
  plan: null,
  server: null,
}, 'ServiceSharedHosting')

export default function createServiceSharedHosting(data) {
  return new SharedHostingRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/SharedHosting.js